"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RbcApi = exports.RbcApiFactory = exports.RbcApiFp = exports.RbcApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * RbcApi - axios parameter creator
 * @export
 */
const RbcApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Soft deletes all circle recommendations provided by recipient_id.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | d |
         * @summary Delete circle recommendations
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1RecommendationsCircle: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, acceptLanguage, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('deleteV1RecommendationsCircle', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('deleteV1RecommendationsCircle', 'recipientId', recipientId);
            const localVarPath = `/v1/recommendations/recipients/{recipient_id}/recommendations`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/recipients/{recipient_id}/recommendations`,
                sdkMethod: 'deleteV1RecommendationsCircle',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Soft delete user recommendations.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Delete recommendations user V1
         * @param {string} userId User ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1RecommendationsUser: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, acceptLanguage }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('deleteV1RecommendationsUser', 'userId', userId);
            const localVarPath = `/v1/recommendations/users/{user_id}/recommendations`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/users/{user_id}/recommendations`,
                sdkMethod: 'deleteV1RecommendationsUser',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Expunge all circle recommendations provided by recipient_id.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | e |
         * @summary Expunge circle recommendations
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeV1RecommendationsCircle: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('expungeV1RecommendationsCircle', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('expungeV1RecommendationsCircle', 'recipientId', recipientId);
            const localVarPath = `/v1/recommendations/recipients/{recipient_id}/recommendations/expunge`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/recipients/{recipient_id}/recommendations/expunge`,
                sdkMethod: 'expungeV1RecommendationsCircle',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Expunge user recommendations.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Expunge recommendations user V1
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeV1RecommendationsUser: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('expungeV1RecommendationsUser', 'userId', userId);
            const localVarPath = `/v1/recommendations/users/{user_id}/recommendations/expunge`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/users/{user_id}/recommendations/expunge`,
                sdkMethod: 'expungeV1RecommendationsUser',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The recommendation\'s generated for the circle is returned. The recommendations can be acted on by any user in the circle who has the appropriate role/perm and other attributes specified in the definition in the backend. This type of recommendation is a shared state and if anyone works on the recommendation then other users in the circle will see the state change. Note by default only **created**, **viewed** and **in_progress** recommendations are returned. If you want to include other statuses then use the **statuses** query param.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | r |
         * @summary Get recommendations which returns the recommendations for the users in the circle.
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate recommendations for certain duration. 1. Must be set to true the first time the user selects the circle so that recommendations is recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user takes a poll, this should be set to true as we know that polls impact recommendations.
         * @param {Set<string>} [statuses] List of statuses to include in the response. If not provided, [**created**, **viewed**, **in_progress**] statuses are included.
         * @param {string} [localDateTime] The local date time of the user with the offset. For example: 2006-01-23T15:04:05+07:00 or 2006-01-23T15:04:05-05:30. The + character has a special meaning in URL, so, encode it to %2b so that the datetime in URL is 2006-01-23T15:04:05%2b07:00.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RecommendationsCircle: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, acceptLanguage, forceRefresh, statuses, localDateTime, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getV1RecommendationsCircle', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getV1RecommendationsCircle', 'recipientId', recipientId);
            const localVarPath = `/v1/recommendations/recipients/{recipient_id}/recommendations`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (forceRefresh !== undefined) {
                localVarQueryParameter['forceRefresh'] = forceRefresh;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = Array.from(statuses);
            }
            if (localDateTime !== undefined) {
                localVarQueryParameter['localDateTime'] = localDateTime;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/recipients/{recipient_id}/recommendations`,
                sdkMethod: 'getV1RecommendationsCircle',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Only an admin user can call this endpoint. The recommendation\'s generated for the circle is returned in context of the userId provided as query param. The recommendations can be acted on by any user in the circle who has the appropriate role/perm and other attributes specified in the definition in the backend. This type of recommendation is a shared state and if anyone works on the recommendation then other users in the circle will see the state change.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get recommendations as admin which returns the recommendations for the userId in the circle.
         * @param {number} recipientId Recipient ID
         * @param {string} userId User ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate recommendations for certain duration. 1. Must be set to true the first time the user selects the circle so that recommendations is recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user takes a poll, this should be set to true as we know that polls impact recommendations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RecommendationsCircleAsAdmin: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, userId, acceptLanguage, forceRefresh, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getV1RecommendationsCircleAsAdmin', 'recipientId', recipientId);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getV1RecommendationsCircleAsAdmin', 'userId', userId);
            const localVarPath = `/v1/recommendations/admin/recipients/{recipient_id}/recommendations`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (forceRefresh !== undefined) {
                localVarQueryParameter['forceRefresh'] = forceRefresh;
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/admin/recipients/{recipient_id}/recommendations`,
                sdkMethod: 'getV1RecommendationsCircleAsAdmin',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The recommendation\'s generated for the user is returned. The recommendations can be acted on by a user who has the appropriate role/perm and other attributes specified in the definition in the backend. This type of recommendation is a private user state and no one else in the circle has access to. The recommendations is generated using all the data across all the circles for the user.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get recommendations which returns the recommendations for the users using the data across all the circles.
         * @param {string} userId User ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate recommendations for certain duration. 1. Must be set to true the first time the user joins the circle so that recommendations is recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user takes a poll, this should be set to true as we know that polls impact recommendations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RecommendationsUser: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, acceptLanguage, forceRefresh, }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getV1RecommendationsUser', 'userId', userId);
            const localVarPath = `/v1/recommendations/users/{user_id}/recommendations`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (forceRefresh !== undefined) {
                localVarQueryParameter['forceRefresh'] = forceRefresh;
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/users/{user_id}/recommendations`,
                sdkMethod: 'getV1RecommendationsUser',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Only an admin user can call this endpoint.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get rules as admin which returns the rules GRL as a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RulesAsAdmin: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({}, options = {}) {
            const localVarPath = `/v1/recommendations/admin/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/admin/rules`,
                sdkMethod: 'getV1RulesAsAdmin',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The circle\'s recommendation state can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | u |
         * @summary Update circle recommendation state
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {string} recommendationDefnId Recommendation definition ID
         * @param {RbcUpdateRecRequest} rbcUpdateRecRequest Update recommendation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateV1RecommendationsCircle: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, recommendationDefnId, rbcUpdateRecRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsCircle', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsCircle', 'recipientId', recipientId);
            // verify required parameter 'recommendationDefnId' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsCircle', 'recommendationDefnId', recommendationDefnId);
            // verify required parameter 'rbcUpdateRecRequest' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsCircle', 'rbcUpdateRecRequest', rbcUpdateRecRequest);
            const localVarPath = `/v1/recommendations/recipients/{recipient_id}/recommendations/{recommendation_defn_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'recommendation_defn_id'}}`, encodeURIComponent(String(recommendationDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/recipients/{recipient_id}/recommendations/{recommendation_defn_id}`,
                sdkMethod: 'updateV1RecommendationsCircle',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rbcUpdateRecRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The circle\'s recommendation preference for the user defined by session token can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint. The preference does not change anything related to circle recommendation and is a user specific information.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | u |
         * @summary Update circle recommendation preference for user
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {string} recommendationDefnId Recommendation definition ID
         * @param {RbcUpdateUserPrefRequest} rbcUpdateUserPrefRequest Update recommendation pref request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateV1RecommendationsCircleUserPref: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, recommendationDefnId, rbcUpdateUserPrefRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsCircleUserPref', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsCircleUserPref', 'recipientId', recipientId);
            // verify required parameter 'recommendationDefnId' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsCircleUserPref', 'recommendationDefnId', recommendationDefnId);
            // verify required parameter 'rbcUpdateUserPrefRequest' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsCircleUserPref', 'rbcUpdateUserPrefRequest', rbcUpdateUserPrefRequest);
            const localVarPath = `/v1/recommendations/recipients/{recipient_id}/recommendations/{recommendation_defn_id}/preference`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'recommendation_defn_id'}}`, encodeURIComponent(String(recommendationDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/recipients/{recipient_id}/recommendations/{recommendation_defn_id}/preference`,
                sdkMethod: 'updateV1RecommendationsCircleUserPref',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rbcUpdateUserPrefRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The user\'s recommendation state can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Update user recommendation state
         * @param {string} userId User ID
         * @param {string} recommendationDefnId Recommendation definition ID
         * @param {RbcUpdateRecRequest} rbcUpdateRecRequest Update recommendation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateV1RecommendationsUser: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, recommendationDefnId, rbcUpdateRecRequest, }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsUser', 'userId', userId);
            // verify required parameter 'recommendationDefnId' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsUser', 'recommendationDefnId', recommendationDefnId);
            // verify required parameter 'rbcUpdateRecRequest' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsUser', 'rbcUpdateRecRequest', rbcUpdateRecRequest);
            const localVarPath = `/v1/recommendations/users/{user_id}/recommendations/{recommendation_defn_id}`
                .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)))
                .replace(`{${'recommendation_defn_id'}}`, encodeURIComponent(String(recommendationDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/users/{user_id}/recommendations/{recommendation_defn_id}`,
                sdkMethod: 'updateV1RecommendationsUser',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rbcUpdateRecRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The user\'s recommendation preference can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint. The preference does not change anything related to recommendation and is a user specific information.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Update user recommendation preference
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} recommendationDefnId Recommendation definition ID
         * @param {RbcUpdateUserPrefRequest} rbcUpdateUserPrefRequest Update recommendation pref request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateV1RecommendationsUserPref: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, userId, recommendationDefnId, rbcUpdateUserPrefRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsUserPref', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsUserPref', 'userId', userId);
            // verify required parameter 'recommendationDefnId' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsUserPref', 'recommendationDefnId', recommendationDefnId);
            // verify required parameter 'rbcUpdateUserPrefRequest' is not null or undefined
            (0, common_1.assertParamExists)('updateV1RecommendationsUserPref', 'rbcUpdateUserPrefRequest', rbcUpdateUserPrefRequest);
            const localVarPath = `/v1/recommendations/users/{user_id}/recommendations/{recommendation_defn_id}/preference`
                .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)))
                .replace(`{${'recommendation_defn_id'}}`, encodeURIComponent(String(recommendationDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/users/{user_id}/recommendations/{recommendation_defn_id}/preference`,
                sdkMethod: 'updateV1RecommendationsUserPref',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rbcUpdateUserPrefRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Only an admin user can call this endpoint. No rules are run. The recommendation defn Id is validated against whats present in backend yaml. When the Get API is called, the rules are run again unless the cached recommendations are returned. If the rules are run again, it is possible the status of this upserted recommendation might change to removed as its not an output from the rules engine. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Upsert circle & user recommendations as admin.
         * @param {RbcUpsertRecRequest} rbcUpsertRecRequest Update recommendation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertV1RecommendationsAsAdmin: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rbcUpsertRecRequest }, options = {}) {
            // verify required parameter 'rbcUpsertRecRequest' is not null or undefined
            (0, common_1.assertParamExists)('upsertV1RecommendationsAsAdmin', 'rbcUpsertRecRequest', rbcUpsertRecRequest);
            const localVarPath = `/v1/recommendations/admin/recommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/admin/recommendations`,
                sdkMethod: 'upsertV1RecommendationsAsAdmin',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rbcUpsertRecRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Only an admin user can call this endpoint. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Delete cached contents for the given cache key.
         * @param {RbcCacheKeys} cacheKey Redis key of the cache to operate on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RecommendationsCacheCacheKeyDelete: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ cacheKey }, options = {}) {
            // verify required parameter 'cacheKey' is not null or undefined
            (0, common_1.assertParamExists)('v1RecommendationsCacheCacheKeyDelete', 'cacheKey', cacheKey);
            const localVarPath = `/v1/recommendations/cache/{cache_key}`.replace(`{${'cache_key'}}`, encodeURIComponent(String(cacheKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/cache/{cache_key}`,
                sdkMethod: 'v1RecommendationsCacheCacheKeyDelete',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.RbcApiAxiosParamCreator = RbcApiAxiosParamCreator;
/**
 * RbcApi - functional programming interface
 * @export
 */
const RbcApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.RbcApiAxiosParamCreator)(configuration);
    return {
        /**
         * Soft deletes all circle recommendations provided by recipient_id.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | d |
         * @summary Delete circle recommendations
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1RecommendationsCircle(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteV1RecommendationsCircle(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Soft delete user recommendations.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Delete recommendations user V1
         * @param {string} userId User ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1RecommendationsUser(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteV1RecommendationsUser(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Expunge all circle recommendations provided by recipient_id.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | e |
         * @summary Expunge circle recommendations
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeV1RecommendationsCircle(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.expungeV1RecommendationsCircle(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Expunge user recommendations.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Expunge recommendations user V1
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeV1RecommendationsUser(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.expungeV1RecommendationsUser(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The recommendation\'s generated for the circle is returned. The recommendations can be acted on by any user in the circle who has the appropriate role/perm and other attributes specified in the definition in the backend. This type of recommendation is a shared state and if anyone works on the recommendation then other users in the circle will see the state change. Note by default only **created**, **viewed** and **in_progress** recommendations are returned. If you want to include other statuses then use the **statuses** query param.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | r |
         * @summary Get recommendations which returns the recommendations for the users in the circle.
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate recommendations for certain duration. 1. Must be set to true the first time the user selects the circle so that recommendations is recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user takes a poll, this should be set to true as we know that polls impact recommendations.
         * @param {Set<string>} [statuses] List of statuses to include in the response. If not provided, [**created**, **viewed**, **in_progress**] statuses are included.
         * @param {string} [localDateTime] The local date time of the user with the offset. For example: 2006-01-23T15:04:05+07:00 or 2006-01-23T15:04:05-05:30. The + character has a special meaning in URL, so, encode it to %2b so that the datetime in URL is 2006-01-23T15:04:05%2b07:00.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RecommendationsCircle(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getV1RecommendationsCircle(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Only an admin user can call this endpoint. The recommendation\'s generated for the circle is returned in context of the userId provided as query param. The recommendations can be acted on by any user in the circle who has the appropriate role/perm and other attributes specified in the definition in the backend. This type of recommendation is a shared state and if anyone works on the recommendation then other users in the circle will see the state change.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get recommendations as admin which returns the recommendations for the userId in the circle.
         * @param {number} recipientId Recipient ID
         * @param {string} userId User ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate recommendations for certain duration. 1. Must be set to true the first time the user selects the circle so that recommendations is recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user takes a poll, this should be set to true as we know that polls impact recommendations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RecommendationsCircleAsAdmin(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getV1RecommendationsCircleAsAdmin(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The recommendation\'s generated for the user is returned. The recommendations can be acted on by a user who has the appropriate role/perm and other attributes specified in the definition in the backend. This type of recommendation is a private user state and no one else in the circle has access to. The recommendations is generated using all the data across all the circles for the user.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get recommendations which returns the recommendations for the users using the data across all the circles.
         * @param {string} userId User ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate recommendations for certain duration. 1. Must be set to true the first time the user joins the circle so that recommendations is recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user takes a poll, this should be set to true as we know that polls impact recommendations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RecommendationsUser(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getV1RecommendationsUser(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Only an admin user can call this endpoint.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get rules as admin which returns the rules GRL as a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RulesAsAdmin(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getV1RulesAsAdmin(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The circle\'s recommendation state can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | u |
         * @summary Update circle recommendation state
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {string} recommendationDefnId Recommendation definition ID
         * @param {RbcUpdateRecRequest} rbcUpdateRecRequest Update recommendation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateV1RecommendationsCircle(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateV1RecommendationsCircle(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The circle\'s recommendation preference for the user defined by session token can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint. The preference does not change anything related to circle recommendation and is a user specific information.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | u |
         * @summary Update circle recommendation preference for user
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {string} recommendationDefnId Recommendation definition ID
         * @param {RbcUpdateUserPrefRequest} rbcUpdateUserPrefRequest Update recommendation pref request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateV1RecommendationsCircleUserPref(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateV1RecommendationsCircleUserPref(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The user\'s recommendation state can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Update user recommendation state
         * @param {string} userId User ID
         * @param {string} recommendationDefnId Recommendation definition ID
         * @param {RbcUpdateRecRequest} rbcUpdateRecRequest Update recommendation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateV1RecommendationsUser(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateV1RecommendationsUser(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The user\'s recommendation preference can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint. The preference does not change anything related to recommendation and is a user specific information.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Update user recommendation preference
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} recommendationDefnId Recommendation definition ID
         * @param {RbcUpdateUserPrefRequest} rbcUpdateUserPrefRequest Update recommendation pref request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateV1RecommendationsUserPref(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateV1RecommendationsUserPref(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Only an admin user can call this endpoint. No rules are run. The recommendation defn Id is validated against whats present in backend yaml. When the Get API is called, the rules are run again unless the cached recommendations are returned. If the rules are run again, it is possible the status of this upserted recommendation might change to removed as its not an output from the rules engine. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Upsert circle & user recommendations as admin.
         * @param {RbcUpsertRecRequest} rbcUpsertRecRequest Update recommendation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertV1RecommendationsAsAdmin(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertV1RecommendationsAsAdmin(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Only an admin user can call this endpoint. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Delete cached contents for the given cache key.
         * @param {RbcCacheKeys} cacheKey Redis key of the cache to operate on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RecommendationsCacheCacheKeyDelete(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RecommendationsCacheCacheKeyDelete(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.RbcApiFp = RbcApiFp;
/**
 * RbcApi - factory interface
 * @export
 */
const RbcApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.RbcApiFp)(configuration);
    return {
        /**
         * Soft deletes all circle recommendations provided by recipient_id.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | d |
         * @summary Delete circle recommendations
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1RecommendationsCircle(params, options) {
            return localVarFp
                .deleteV1RecommendationsCircle(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Soft delete user recommendations.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Delete recommendations user V1
         * @param {string} userId User ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV1RecommendationsUser(params, options) {
            return localVarFp
                .deleteV1RecommendationsUser(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Expunge all circle recommendations provided by recipient_id.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | e |
         * @summary Expunge circle recommendations
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeV1RecommendationsCircle(params, options) {
            return localVarFp
                .expungeV1RecommendationsCircle(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Expunge user recommendations.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Expunge recommendations user V1
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expungeV1RecommendationsUser(params, options) {
            return localVarFp
                .expungeV1RecommendationsUser(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * The recommendation\'s generated for the circle is returned. The recommendations can be acted on by any user in the circle who has the appropriate role/perm and other attributes specified in the definition in the backend. This type of recommendation is a shared state and if anyone works on the recommendation then other users in the circle will see the state change. Note by default only **created**, **viewed** and **in_progress** recommendations are returned. If you want to include other statuses then use the **statuses** query param.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | r |
         * @summary Get recommendations which returns the recommendations for the users in the circle.
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate recommendations for certain duration. 1. Must be set to true the first time the user selects the circle so that recommendations is recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user takes a poll, this should be set to true as we know that polls impact recommendations.
         * @param {Set<string>} [statuses] List of statuses to include in the response. If not provided, [**created**, **viewed**, **in_progress**] statuses are included.
         * @param {string} [localDateTime] The local date time of the user with the offset. For example: 2006-01-23T15:04:05+07:00 or 2006-01-23T15:04:05-05:30. The + character has a special meaning in URL, so, encode it to %2b so that the datetime in URL is 2006-01-23T15:04:05%2b07:00.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RecommendationsCircle(params, options) {
            return localVarFp
                .getV1RecommendationsCircle(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Only an admin user can call this endpoint. The recommendation\'s generated for the circle is returned in context of the userId provided as query param. The recommendations can be acted on by any user in the circle who has the appropriate role/perm and other attributes specified in the definition in the backend. This type of recommendation is a shared state and if anyone works on the recommendation then other users in the circle will see the state change.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get recommendations as admin which returns the recommendations for the userId in the circle.
         * @param {number} recipientId Recipient ID
         * @param {string} userId User ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate recommendations for certain duration. 1. Must be set to true the first time the user selects the circle so that recommendations is recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user takes a poll, this should be set to true as we know that polls impact recommendations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RecommendationsCircleAsAdmin(params, options) {
            return localVarFp
                .getV1RecommendationsCircleAsAdmin(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * The recommendation\'s generated for the user is returned. The recommendations can be acted on by a user who has the appropriate role/perm and other attributes specified in the definition in the backend. This type of recommendation is a private user state and no one else in the circle has access to. The recommendations is generated using all the data across all the circles for the user.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get recommendations which returns the recommendations for the users using the data across all the circles.
         * @param {string} userId User ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate recommendations for certain duration. 1. Must be set to true the first time the user joins the circle so that recommendations is recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user takes a poll, this should be set to true as we know that polls impact recommendations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RecommendationsUser(params, options) {
            return localVarFp
                .getV1RecommendationsUser(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Only an admin user can call this endpoint.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get rules as admin which returns the rules GRL as a string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getV1RulesAsAdmin(params, options) {
            return localVarFp
                .getV1RulesAsAdmin(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * The circle\'s recommendation state can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | u |
         * @summary Update circle recommendation state
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {string} recommendationDefnId Recommendation definition ID
         * @param {RbcUpdateRecRequest} rbcUpdateRecRequest Update recommendation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateV1RecommendationsCircle(params, options) {
            return localVarFp
                .updateV1RecommendationsCircle(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * The circle\'s recommendation preference for the user defined by session token can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint. The preference does not change anything related to circle recommendation and is a user specific information.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | u |
         * @summary Update circle recommendation preference for user
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {number} recipientId Recipient ID
         * @param {string} recommendationDefnId Recommendation definition ID
         * @param {RbcUpdateUserPrefRequest} rbcUpdateUserPrefRequest Update recommendation pref request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateV1RecommendationsCircleUserPref(params, options) {
            return localVarFp
                .updateV1RecommendationsCircleUserPref(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * The user\'s recommendation state can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Update user recommendation state
         * @param {string} userId User ID
         * @param {string} recommendationDefnId Recommendation definition ID
         * @param {RbcUpdateRecRequest} rbcUpdateRecRequest Update recommendation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateV1RecommendationsUser(params, options) {
            return localVarFp
                .updateV1RecommendationsUser(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * The user\'s recommendation preference can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint. The preference does not change anything related to recommendation and is a user specific information.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Update user recommendation preference
         * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
         * @param {string} userId User ID
         * @param {string} recommendationDefnId Recommendation definition ID
         * @param {RbcUpdateUserPrefRequest} rbcUpdateUserPrefRequest Update recommendation pref request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateV1RecommendationsUserPref(params, options) {
            return localVarFp
                .updateV1RecommendationsUserPref(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Only an admin user can call this endpoint. No rules are run. The recommendation defn Id is validated against whats present in backend yaml. When the Get API is called, the rules are run again unless the cached recommendations are returned. If the rules are run again, it is possible the status of this upserted recommendation might change to removed as its not an output from the rules engine. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Upsert circle & user recommendations as admin.
         * @param {RbcUpsertRecRequest} rbcUpsertRecRequest Update recommendation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertV1RecommendationsAsAdmin(params, options) {
            return localVarFp
                .upsertV1RecommendationsAsAdmin(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Only an admin user can call this endpoint. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Delete cached contents for the given cache key.
         * @param {RbcCacheKeys} cacheKey Redis key of the cache to operate on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RecommendationsCacheCacheKeyDelete(params, options) {
            return localVarFp
                .v1RecommendationsCacheCacheKeyDelete(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.RbcApiFactory = RbcApiFactory;
/**
 * RbcApi - object-oriented interface
 * @export
 * @class RbcApi
 * @extends {BaseAPI}
 */
class RbcApi extends base_1.BaseAPI {
    /**
     * URL `/v1/recommendations/recipients/{recipient_id}/recommendations`
     * Soft deletes all circle recommendations provided by recipient_id.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | d |
     * @summary Delete circle recommendations
     * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
     * @param {number} recipientId Recipient ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    deleteV1RecommendationsCircle(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .deleteV1RecommendationsCircle(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/users/{user_id}/recommendations`
     * Soft delete user recommendations.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Delete recommendations user V1
     * @param {string} userId User ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    deleteV1RecommendationsUser(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .deleteV1RecommendationsUser(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/recipients/{recipient_id}/recommendations/expunge`
     * Expunge all circle recommendations provided by recipient_id.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | e |
     * @summary Expunge circle recommendations
     * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
     * @param {number} recipientId Recipient ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    expungeV1RecommendationsCircle(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .expungeV1RecommendationsCircle(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/users/{user_id}/recommendations/expunge`
     * Expunge user recommendations.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Expunge recommendations user V1
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    expungeV1RecommendationsUser(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .expungeV1RecommendationsUser(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/recipients/{recipient_id}/recommendations`
     * The recommendation\'s generated for the circle is returned. The recommendations can be acted on by any user in the circle who has the appropriate role/perm and other attributes specified in the definition in the backend. This type of recommendation is a shared state and if anyone works on the recommendation then other users in the circle will see the state change. Note by default only **created**, **viewed** and **in_progress** recommendations are returned. If you want to include other statuses then use the **statuses** query param.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | r |
     * @summary Get recommendations which returns the recommendations for the users in the circle.
     * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
     * @param {number} recipientId Recipient ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate recommendations for certain duration. 1. Must be set to true the first time the user selects the circle so that recommendations is recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user takes a poll, this should be set to true as we know that polls impact recommendations.
     * @param {Set<string>} [statuses] List of statuses to include in the response. If not provided, [**created**, **viewed**, **in_progress**] statuses are included.
     * @param {string} [localDateTime] The local date time of the user with the offset. For example: 2006-01-23T15:04:05+07:00 or 2006-01-23T15:04:05-05:30. The + character has a special meaning in URL, so, encode it to %2b so that the datetime in URL is 2006-01-23T15:04:05%2b07:00.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    getV1RecommendationsCircle(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .getV1RecommendationsCircle(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/admin/recipients/{recipient_id}/recommendations`
     * Only an admin user can call this endpoint. The recommendation\'s generated for the circle is returned in context of the userId provided as query param. The recommendations can be acted on by any user in the circle who has the appropriate role/perm and other attributes specified in the definition in the backend. This type of recommendation is a shared state and if anyone works on the recommendation then other users in the circle will see the state change.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Get recommendations as admin which returns the recommendations for the userId in the circle.
     * @param {number} recipientId Recipient ID
     * @param {string} userId User ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate recommendations for certain duration. 1. Must be set to true the first time the user selects the circle so that recommendations is recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user takes a poll, this should be set to true as we know that polls impact recommendations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    getV1RecommendationsCircleAsAdmin(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .getV1RecommendationsCircleAsAdmin(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/users/{user_id}/recommendations`
     * The recommendation\'s generated for the user is returned. The recommendations can be acted on by a user who has the appropriate role/perm and other attributes specified in the definition in the backend. This type of recommendation is a private user state and no one else in the circle has access to. The recommendations is generated using all the data across all the circles for the user.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Get recommendations which returns the recommendations for the users using the data across all the circles.
     * @param {string} userId User ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {boolean} [forceRefresh] The backend has a configurable cache to not recalculate recommendations for certain duration. 1. Must be set to true the first time the user joins the circle so that recommendations is recalculated with this new user in the circle. 2. If there is a need to force a recalculation then this is set to true. For example, after a user takes a poll, this should be set to true as we know that polls impact recommendations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    getV1RecommendationsUser(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .getV1RecommendationsUser(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/admin/rules`
     * Only an admin user can call this endpoint.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Get rules as admin which returns the rules GRL as a string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    getV1RulesAsAdmin(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .getV1RulesAsAdmin(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/recipients/{recipient_id}/recommendations/{recommendation_defn_id}`
     * The circle\'s recommendation state can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | u |
     * @summary Update circle recommendation state
     * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
     * @param {number} recipientId Recipient ID
     * @param {string} recommendationDefnId Recommendation definition ID
     * @param {RbcUpdateRecRequest} rbcUpdateRecRequest Update recommendation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    updateV1RecommendationsCircle(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .updateV1RecommendationsCircle(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/recipients/{recipient_id}/recommendations/{recommendation_defn_id}/preference`
     * The circle\'s recommendation preference for the user defined by session token can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint. The preference does not change anything related to circle recommendation and is a user specific information.  |Feature|Dataclass|Permission| |-------|---------|----------| | recommendations | rbc | u |
     * @summary Update circle recommendation preference for user
     * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
     * @param {number} recipientId Recipient ID
     * @param {string} recommendationDefnId Recommendation definition ID
     * @param {RbcUpdateUserPrefRequest} rbcUpdateUserPrefRequest Update recommendation pref request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    updateV1RecommendationsCircleUserPref(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .updateV1RecommendationsCircleUserPref(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/users/{user_id}/recommendations/{recommendation_defn_id}`
     * The user\'s recommendation state can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Update user recommendation state
     * @param {string} userId User ID
     * @param {string} recommendationDefnId Recommendation definition ID
     * @param {RbcUpdateRecRequest} rbcUpdateRecRequest Update recommendation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    updateV1RecommendationsUser(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .updateV1RecommendationsUser(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/users/{user_id}/recommendations/{recommendation_defn_id}/preference`
     * The user\'s recommendation preference can be updated using this API. The recommendation_defn_id parameter is returned for each recommendation when its fetched using the get endpoint. The preference does not change anything related to recommendation and is a user specific information.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Update user recommendation preference
     * @param {string} circleAuthorizationToken Circle JWT token that contains current user\&#39;s UserID, role, permissions, features and circle information
     * @param {string} userId User ID
     * @param {string} recommendationDefnId Recommendation definition ID
     * @param {RbcUpdateUserPrefRequest} rbcUpdateUserPrefRequest Update recommendation pref request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    updateV1RecommendationsUserPref(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .updateV1RecommendationsUserPref(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/admin/recommendations`
     * Only an admin user can call this endpoint. No rules are run. The recommendation defn Id is validated against whats present in backend yaml. When the Get API is called, the rules are run again unless the cached recommendations are returned. If the rules are run again, it is possible the status of this upserted recommendation might change to removed as its not an output from the rules engine. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Upsert circle & user recommendations as admin.
     * @param {RbcUpsertRecRequest} rbcUpsertRecRequest Update recommendation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    upsertV1RecommendationsAsAdmin(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .upsertV1RecommendationsAsAdmin(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/cache/{cache_key}`
     * Only an admin user can call this endpoint. |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Delete cached contents for the given cache key.
     * @param {RbcCacheKeys} cacheKey Redis key of the cache to operate on.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbcApi
     */
    v1RecommendationsCacheCacheKeyDelete(params, options) {
        return (0, exports.RbcApiFp)(this.configuration)
            .v1RecommendationsCacheCacheKeyDelete(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.RbcApi = RbcApi;
//# sourceMappingURL=rbc-api.js.map